import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;


@Component({
  selector: 'app-verifymail',
  templateUrl: './verifymail.component.html',
  styleUrls: ['./verifymail.component.scss']
})
export class VerifymailComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public currentUrl:any ='';
  public token:any='';
  public usertYpes:any=1;
  public verificationSuccess:boolean = false;
  public verificationMessage:string = '';

  constructor(public router: Router, private service: GlobalService) {   
  }

  ngOnInit(): void {
    var mm:any =(this.router.url).split('/');  
    this.currentUrl ='/'+ mm[1];
    if(mm.length ==3){
      if( mm[2].includes("?")){
        var ss:any=mm[2].split('?')
        this.token = ss[0];
        var ssd:any= ss[1].split('=');
        this.usertYpes=ssd[1];
      } else {
        this.token = mm[2];
      }
      if(this.currentUrl == '/verify-email'   || this.currentUrl == '/verify-email-mobile' ){
        localStorage.setItem('grw_upload_iamge','1');
        this.OnReset();
      } else{
       if(this.currentUrl == '/success-account-verification' || this.currentUrl == '/confirmation-account-verification'){
        this.callBack('/confirmation-account-verification?stripe_token='+this.token);  
       }  else {
        this.callBackFailed('/failed-account-verification?stripe_token='+this.token);        
      }      
    }
  }
  }

  OnReset(){ 
    this.submitted = true;
    this.loading = true;
    const url = "/verify-email";
    const detail = {
      "verification_token":this.token,
    };
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.submitted = false;
        this.service.successAlert(response.message);
        localStorage.setItem('grw_login',<any> JSON.stringify(response.data || {}));
        this.service.setSubject(response.data);
        localStorage.setItem('grw_token',response.data.token);
        this.loading = false;
        // this.router.navigate(['/signin']);
      } else {
        this.service.dangerAlert(response.message);
        this.loading = false;
      }
    }), (error) => { this.loading =false; });
  }

  
  callBack(url:any){
    this.loading = true;
    this.service.GetApi(url).subscribe(((response:any)=>{
      this.loading = false;
      if(response.success ==1){
        this.verificationSuccess = true;

        // Update localStorage with new Stripe account status
        const loginData = getLocalJSON('grw_login');
        loginData.stripe_account_verify = true;
        if (response.data?.stripe_connect_status) {
          loginData.stripe_connect_status = response.data.stripe_connect_status;
        }
        if (response.data?.stripe_charges_enabled !== undefined) {
          loginData.stripe_charges_enabled = response.data.stripe_charges_enabled;
        }
        if (response.data?.stripe_payouts_enabled !== undefined) {
          loginData.stripe_payouts_enabled = response.data.stripe_payouts_enabled;
        }
        if (response.data?.stripe_connect_country) {
          loginData.stripe_connect_country = response.data.stripe_connect_country;
        }
        if (response.data?.userCurrency) {
          loginData.userCurrency = response.data.userCurrency;
          localStorage.setItem('grw_logincurrency', response.data.userCurrency);
        }
        if (response.data?.userCurrencySymbol) {
          loginData.userCurrencySymbol = response.data.userCurrencySymbol;
          localStorage.setItem('grw_currencySymbol', response.data.userCurrencySymbol);
        }
        localStorage.setItem('grw_login', JSON.stringify(loginData));
        this.service.setSubject(loginData);
        this.service.successAlert('Your Stripe account has been connected successfully!');
      } else {
        this.verificationSuccess = false;
        this.verificationMessage = response.message || 'Account verification failed. Please try again.';
        this.service.dangerAlert(this.verificationMessage);
      }
    }), (error) => {
      this.loading = false;
      this.verificationSuccess = false;
      this.verificationMessage = 'Something went wrong during verification. Please try again.';
      this.service.dangerAlert(this.verificationMessage);
    });
  }

  callBackFailed(url:any){
    this.loading = true;
    this.service.GetApi(url).subscribe(((response:any)=>{
      this.loading = false;
      this.verificationSuccess = false;
      this.verificationMessage = response.message || 'Your account not verified, Please try again...';
    }), (error) => {
      this.loading = false;
      this.verificationSuccess = false;
      this.verificationMessage = 'Something went wrong. Please try again.';
    });
  }

}
